var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.ORDER_ABNORMAL_FIVE_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channel", "storeIdList"],
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("OrderShortageManagement.Order"),
                          prop: "orderNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("orderNewPatch.order") },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orderNo", $$v)
                            },
                            expression: "queryParams.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("OrderShortageManagement.party"),
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "OrderShortageManagement.party"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime_order,
                            callback: function ($$v) {
                              _vm.queryParamsTime_order = $$v
                            },
                            expression: "queryParamsTime_order",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.isShow
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                              prop: "receiverName",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c("BjFrontendExport", {
                      staticClass: "main-btn",
                      attrs: {
                        type: "primary",
                        "label-list": _vm.labelList,
                        rows: _vm.selectedRows,
                        "file-name": "Order out of stock.csv",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onExportSKU },
                      },
                      [_vm._v(_vm._s(_vm.$t("exportText")) + "SKU")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.cancelOrder },
                      },
                      [_vm._v(_vm._s(_vm.$t("bulkDelCancelText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.reallocate },
                      },
                      [_vm._v(_vm._s(_vm.$t("orderNewPatch.Reprocess")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(
                                                scope.row.cusId
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.webReference)
                                            ),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.webReference,
                                            },
                                          }),
                                        ]
                                      : col.prop === "orderTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "creationDate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOperateTwoHour")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "shippingMethod"
                                      ? [
                                          [
                                            "CUSTOMER MANUAL",
                                            "CSG MANUAL",
                                            "PICKUP",
                                          ].includes(scope.row[col.prop])
                                            ? _c(
                                                "el-tag",
                                                { attrs: { type: "success" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row[col.prop])
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row[col.prop])
                                                ),
                                              ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("operationText")) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("InternalOrder.ps1")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                          staticStyle: { color: "#082dc3" },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        directives: [
                                          {
                                            name: "hasDropdownChildren",
                                            rawName: "v-hasDropdownChildren",
                                          },
                                        ],
                                        on: {
                                          command: function ($event) {
                                            return _vm.command(
                                              $event,
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.common.operate"
                                                )
                                              )
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              { attrs: { command: "edit" } },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("editText")) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              { attrs: { command: "cancel" } },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("cancelText")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }